
<template>
  <tbody style="cursor: pointer">
    <v-menu
      v-if="booking != null"
      v-model="menu[booking.id.toString()]"
      offset-y
      max-width="200"
      nudge-right="100"
      :close-on-content-click="false"
      :disabled="embedded"
      lazy
    >
      <template v-slot:activator="{ on }">
        <tr
          :class="{ pulsate : booking.waiting_time &&  isWaitingChargesUnusual(booking.waiting_time) && booking.payment_type == 'card' }"
          v-if="booking != null"
          :id="taxi.id"
          valign="top"
          :style="colorForTaxi(taxi, booking.id, 'left')"
          v-on="on"
          @click="setSelectedBooking(booking.id, -1)"
        >
          <td>
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <div class="fixed-table-row-2">
                  <span v-on="on">
                    <b>{{callsignPrefixForDriver(taxi)}}{{ taxi.driver.callsign }}</b>
                    {{ shortName(taxi.driver.name) }}
                  </span>
                </div>
              </template>
              <p v-html="tooltipForTaxi(taxi)" />
            </v-tooltip>
          </td>
          <td :style="colorForTaxi(taxi, booking.id, 'right')">
            {{ timeForBooking(booking.pickup_time, booking.asap) }}
          </td>
          <td>
            {{ etaForBooking }}m
            <b>{{
              booking.pob_time == null ? "/" + etaDate(etaForBookingMinutes) : ""
            }}</b>
          </td>
          <td>
            <div class="fixed-table-row">
              {{ prettify(booking.pickup_location.description) }}
            </div>
          </td>
          <td>
            <ViasForBooking :booking="booking" />
          </td>
          <td>
            <div class="fixed-table-row">
              {{ destinationForBooking(booking) }}
            </div>
          </td>
          <td v-if="!expanded">
              <span style="display: none" data-type="metadata">{{ getViaInfoStringForBooking(booking) }}</span>
            <div class="fixed-table-row">
              {{ nameOrRoomForCustomerForBooking(booking) }}
              <v-icon x-small v-if="isVipCustomer(booking)" title="VIP Customer">mdi-star</v-icon>
            </div>
          </td>
          <td v-if="!expanded">
            <AttributesForBookingCell :booking="booking" />
          </td>
          <td style="display:none;">
            {{ JSON.stringify(booking, getCircularReplacer()) }}
          </td>
          <td style="display:none;">
            {{ 'd'+taxi.driver.callsign }}
          </td>
        </tr>
      </template>
      <BookingMenu
        :booking="booking"
        @copy="copy(booking)"
        @edit="edit(booking.id)"
        @close="menu[booking.id.toString()] = false"
        @track="setSelectedTaxi(taxi.id)"
        @reassign="reassign(booking.id)"
      />
    </v-menu>
    <v-menu
      v-for="(booking, index) in followOnJobsForTaxi"
      v-if="taxi.followOnJobs != null"
      v-model="menu[booking.id.toString()]"
      offset-y
      lazy
      max-width="200"
      nudge-right="100"
      :close-on-content-click="false"
      :disabled="embedded"
    >
      <template v-slot:activator="{ on }">
        <tr
          valign="top"
          :style="colorForFollowOn(booking)"
          v-on="on"
          @click="setSelectedBooking(booking.id, -1)"
        >
          <td :style="colorForTaxiFollowOn(taxi, 'left', booking)">
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <div class="fixed-table-row-2">
                  <span v-on="on">
                    <b>{{ taxi.driver.callsign }}</b>
                    &nbsp;{{ index + 1 }}
                  </span>
                </div>
              </template>
              <p v-html="tooltipForTaxi(taxi)" />
            </v-tooltip>
          </td>
          <td :style="colorForTaxiFollowOn(taxi, 'right', booking)">
            {{ timeForBooking(booking.pickup_time, booking.asap) }}
          </td>
          <td>
            {{ etaForFollowOnBooking(booking) }}m
            <b>{{
              booking.pob_time == null
                ? "/" + etaTimeForFollowOnBooking(booking)
                : ""
            }}</b>
          </td>
          <td>
            <div class="fixed-table-row">
              {{ prettify(booking.pickup_location.description) }}
            </div>
          </td>
          <td>
            <ViasForBooking :booking="booking" />
          </td>
          <td>
            <div class="fixed-table-row">
              {{ destinationForBooking(booking) }}
            </div>
          </td>
          <td v-if="!expanded" :data-meta="getViaInfoStringForBooking(booking)">
            <div class="fixed-table-row">
              {{ nameOrRoomForCustomerForBooking(booking) }}
            </div>
          </td>
          <td v-if="!expanded">
            <AttributesForBookingCell :booking="booking" />
          </td>
          <td style="display:none;">
            {{ JSON.stringify(booking, getCircularReplacer()) }}
          </td>
          <td style="display:none;">
            {{ 'd'+taxi.driver.callsign }}
          </td>
        </tr>
      </template>
      <BookingMenu
        :booking="booking"
        :allow-finish="false"
        @copy="copy(booking)"
        @edit="edit(booking.id)"
        @close="menu[booking.id.toString()] = false"
        @track="setSelectedBooking(booking.id, taxi.id)"
        @reassign="reassign(booking.id)"
      />
    </v-menu>
  </tbody>
</template>

<script>
import BookingMenu from "@/components/widget/menu/BookingMenu.vue";

import AttributesForBookingCell from "@/components/widget/AttributesForBookingCell.vue";
import moment from "moment";

import { Overwatch } from "@/components/util/Overwatch.js";

import ViasForBooking from "@/components/overwatch/ViasForBooking.vue";

export default {
  name: "ActiveTaxiTableRows",
  components: {
    AttributesForBookingCell,
    BookingMenu,
    ViasForBooking,
  },
  props: {
    taxi: Object,
    selectedTaxi: Number,
    selectedBooking: Number,
    setSelectedTaxi: Function,
    setSelectedBooking: Function,
    embedded: {
      type: Boolean,
      default: false
    },
    expanded: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      ABOUT_TO_CLEAR_TIME: 1,
      WAITING_TIME_CHARGES_ANIMATION_KICK_IN_THRESHOLD: 50,
      menu: {},
    };
  },
  computed: {
    booking: function () {
      if (this.taxi.currentBookingTaxi != null) {
        var booking = this.taxi.currentBookingTaxi.booking;
        // modify booking to have reference to current taxi -- used for assign trip
        booking.currentTaxi = this.taxi;
        return booking;
      } else {
        console.log("No current booking taxi??");
        return null;
      }
    },
    etaForBooking: function () {
      if (this.taxi.currentBookingTaxi != null) {
        return this.minutesToHoursMinutesString(
          this.taxi.currentBookingTaxi.taxi.eta
        );
      }
    },
    etaForBookingMinutes: function () {
      if (this.taxi.currentBookingTaxi != null) {
        return this.taxi.currentBookingTaxi.taxi.eta;
      }
    },
    followOnJobsForTaxi: function () {
      return this.taxi.followOnJobs;
    },
  },
  methods: {
    callsignPrefixForDriver(driver) {
      var group = "";

      console.log(driver);
      console.log("booking group" + this.$store.state.driverGroups.length);

      for (var i = 0; i < this.$store.state.driverGroups.length; i++) {
        if (driver.driver_group_id == this.$store.state.driverGroups[i].id) {
          group = this.$store.state.driverGroups[i].callsignPrefix;
        }
      }

      
      return group;
    },
    isWaitingChargesUnusual(waitTimes) {
      let charges = 0.00
      if (waitTimes && waitTimes.charges) {
        charges = (waitTimes.charges/100.00)
      }
      if (charges > this.WAITING_TIME_CHARGES_ANIMATION_KICK_IN_THRESHOLD) {
        return true;
      }
      return false
    },
    isVipCustomer (b) {
      return b.vip_customer ? b.vip_customer == true : false
    },
    getCircularReplacer: function () {
      const seen = new WeakSet();
      return (key, value) => {
        if (typeof value === "object" && value !== null) {
          if (seen.has(value)) {
            return;
          }
          seen.add(value);
        }
        return value;
      };
    },
    copy: function (booking) {
      this.$emit("copy", booking);
    },
    edit: function (bookingID) {
      this.$emit("edit", bookingID);
    },
    reassign: function (b) {
      this.$emit("reassign", b);
    },
    etaForFollowOnBooking: function (booking) {
      for (var i = 0; i < booking.follow_on_taxis.length; i++) {
        var taxi = booking.follow_on_taxis[i];
        if (taxi.eta != null) {
          return this.minutesToHoursMinutesString(taxi.eta);
        }
      }
      return "";
    },
    etaTimeForFollowOnBooking: function (booking) {
      for (var i = 0; i < booking.follow_on_taxis.length; i++) {
        var taxi = booking.follow_on_taxis[i];
        if (taxi.eta != null) {
          return moment(new Date()).add(taxi.eta, "minutes").format("HH:mm");
        }
      }
      return "";
    },
    timeForBooking: function (timeString, asap) {
      var time = moment(timeString, "DD/MM/YYYY HH:mm");

      var timeFormatted = `${time.format("HH:mm")}`;

      if (asap == true) {
        timeFormatted = timeFormatted;
      }

      return timeFormatted;
    },
    etaDate: function (eta) {
      if (this.taxi.currentBookingTaxi != null) {
        return moment(new Date()).add(eta, "minutes").format("HH:mm");
      }
    },
    minutesToHoursMinutesString: function (minutes) {
      var duration = moment.duration(minutes, "minutes");

      if (minutes == 0) {
        return 0;
      }

      var hoursMinutesString = Overwatch.durationToHoursMinutesString(
        duration,
        ""
      );

      return hoursMinutesString;
    },
    colorForTaxi: function (taxi, selectedBooking, side) {
      var ow = new Overwatch(
        [this.taxi],
        [this.taxi.currentBookingTaxi.booking]
      );

      var style = { backgroundColor: ow.colorForTaxi(taxi) };

      if (taxi.in_emergency) {
        style.backgroundColor = "red";
      }

      if (side == "right") {
        style.paddingRight = "3px";
      }

      if (this.selectedBooking == selectedBooking) {
        style.boxShadow = "inset 0 0 0 99999px rgba(0,0,0,0.15)";
      } else {
      }

      return style;
    },
    colorForFollowOn: function (booking) {
      var style = {};

      if (this.selectedBooking == booking.id) {
        // style.backgroundColor = "red";
        style.boxShadow = "inset 0 0 0 99999px rgba(0,0,0,0.15)";
      }

      var ow = new Overwatch([this.taxi], null);

      if (ow.fojIsRunningLate(booking)) {
        style.backgroundColor = "#FFD580"
      }

      return style;
    },
    colorForTaxiFollowOn: function (taxi, side, booking) {
      var ow = new Overwatch([this.taxi], null);

      var style = { backgroundColor: ow.colorForFollowOnTaxi(taxi, booking) };

      if (taxi.in_emergency) {
        style.backgroundColor = "red";
      }

      if (side == "right") {
        style.paddingRight = "3px";
      }

      if (this.selectedBooking == booking.id) {
        // style.backgroundColor = "red";
        style.boxShadow = "inset 0 0 0 99999px rgba(0,0,0,0.15)";
      }

      return style;
    },
    prettify: function (d) {
      return Overwatch.prettifyAddress(d);
    },
    destinationForBooking: function (b) {
      return Overwatch.destinationForBooking(b);
    },
    shortName: function (d) {
      return d.substring(0, 10);
    },
    nameOrRoomForCustomerForBooking: function (b) {
      
      if (b.room_number != null && b.room_number != "" && b.business_customer_name != null && b.business_customer_name != "") {
        return b.room_number + " - " + b.business_customer_name.substring(0, Math.min(5, b.business_customer_name.length));  
      } else if (b.business_customer_name != null && b.business_customer_name != "") {
        return b.business_customer_name;
      } else if (b.room_number != null && b.room_number != "") {
        return b.room_number + " - " + b.customer_name.substring(0, Math.min(5, b.customer_name.length));
      } else {
        return b.customer_name;
      }
    },
    getViaInfoStringForBooking: function (b) {
        if (b.via_info && b.via_info.length) {
            return JSON.stringify(b.via_info).toUpperCase()
        }
        return ''
    },
    tooltipForTaxi: function (taxi) {
      var ow = new Overwatch(this.taxis, this.bookings);

      return ow.tooltipForTaxi(taxi);
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
.fixed-table-row {
  overflow: hidden;
  height: 16px;
}

.fixed-table-row-truncate {
  overflow: hidden;
  height: 16px;
}


.fixed-table-row-2 {
  height: 16px;
  overflow: hidden;
  text-overflow: clip;
  max-lines: 1;
  white-space: nowrap;
  word-wrap: break-word;
  word-break: break-all;
}

@keyframes abnormal-animation {
  0% {
    background-color: transparent;
  }
  50% {
    background-color: #ff0000;
  }
  100% {
    background-color: transparent;
  }
}

.abnormal {
  animation: abnormal-animation 1s linear infinite;
}

@keyframes pulsate {
  0% {
    background-color: transparent;
  }
  50% {
    background-color: rgba(33, 12, 224, 0.98);
    opacity: 0.5;
  }
  100% {
    background-color: transparent;
  }
}

.pulsate {
  color: whitesmoke;
  animation: pulsate 1.5s linear infinite;
}


@keyframes rotateAndScale {
  0% {
    transform: rotate(0deg) scale(1);
  }
  50% {
    transform: rotate(1deg) scale(1.05);
    background-color: #FFA500;
  }
  100% {
    transform: rotate(0deg) scale(1);
  }
}

.rotateAndScale {
  animation: rotateAndScale 2s linear infinite;
  color: whitesmoke;
}
</style>
